import React, { Fragment } from "react";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import ReportFraInfoSectionContainer from "../../../../libraries/ReportGenerator/ReportFraInfoSection";
import { ReportGroupingUtils } from "../../utils/reportGroupingUtils";

import Periodic92And184DaysReport from "./92And184Days";
import HandBrakeReport from "./HandBrake";
import EventRecorderReport from "./EventRecorder";
import EventRecorderMicroProcessorReport from "./EventRecorderMicroProcessor";
import LoadMeterReport from "./LoadMeter";
import GandOAnnualReport from "./GAndOAnnual";
import EMDPrimeMoverInspectionReport from "./EMDPrimeMoverAnnual";
import CLMBLoadMeterReport from "./LoadMeter/CLMB";
import CLMB_Periodic92And184DaysReport from "./92And184Days/CLMB";
import reportByVersion from "../../utils/reportVersions";

const PeriodicCodes = ["periodic92Days", "periodic184Days", "periodic368Days"];
const OtherCodes = ["eventRecordMicroprocessorTest27c", "eventRecordTest25d", "handBreakTest105c"];
const Annual = ["emdPrimeMoverInspection", "GandO368Days"];
export const DefaultChecklistReports = (props) => {
  const { reportData, isPreview } = props;
  if (isPreview) {
    return <ViewReport2 data={{}} />;
  }
  let reportsByDateAndUser = ReportGroupingUtils.groupReportsByDateAndUser(reportData);
  let grouped = ReportGroupingUtils.filterReportsByTestCodes(reportsByDateAndUser, [...PeriodicCodes, ...OtherCodes, ...Annual]);
  let decodedReports = ReportGroupingUtils.decodeTestsInReportGroups(grouped);
  return decodedReports.map((report, i) => {
    return <ViewReport2 key={i} data={report} {...props} />;
  });
};

const ViewReport2 = (props) => {
  const { data, title } = props;
  const { decodedData } = data;

  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title={title} fontSizeOverride={"35px"} />
      <ReportFraInfoSectionContainer {...props} />
      {decodedData.map((singleReport, index) => {
        const { testCode, otherInfo } = singleReport;
        let version = (otherInfo || {}).ver || "default";

        switch (testCode) {
          case "periodic368Days": {
            let AnnualReport = reportByVersion(version, testCode);
            return <AnnualReport singleReport={singleReport} key={index} />;
          }
          case "periodic92Days": {
            let Periodic92days = reportByVersion(version, testCode);
            return <Periodic92days singleReport={singleReport} key={index} />;
          }
          case "periodic184Days": {
            return <Periodic92And184DaysReport singleReport={singleReport} key={index} />;
          }
          case "eventRecordMicroprocessorTest27c": {
            return <EventRecorderMicroProcessorReport singleReport={singleReport} key={index} />;
          }
          case "eventRecordTest25d": {
            return <EventRecorderReport singleReport={singleReport} key={index} />;
          }
          case "handBreakTest105c": {
            return <HandBrakeReport singleReport={singleReport} key={index} />;
          }
          case "emdPrimeMoverInspection": {
            return <EMDPrimeMoverInspectionReport singleReport={singleReport} key={index} />;
          }
          case "GandO368Days": {
            return <GandOAnnualReport singleReport={singleReport} key={index} />;
          }
          default:
            null;
        }
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/CheckListReports.jsx